import { HStack } from "@repo/components/src/ui/hstack";
import { Text } from "@repo/components/src/ui/text";
import { Href, Link } from "expo-router";
import { ChevronRight } from "lucide-react-native";
import React from "react";
import { Button, ButtonText } from "../../ui/button";

export type BreadcrumbItem = {
  label: string;
  href?: Href;
};

type BreadcrumbsProps = {
  items: BreadcrumbItem[];
};

const Breadcrumbs = ({ items }: BreadcrumbsProps) => {
  const totalItems = items.length;
  return (
    <HStack space="sm" className="items-center min-w-0 flex-1 flex-wrap">
      {items.map((item, index) => (
        <React.Fragment key={item.label}>
          {index > 0 && (
            <ChevronRight size={16} className="text-typography-400" />
          )}
          {item.href ? (
            <Link href={item.href} asChild>
              <Button
                variant="link"
                action={index < totalItems - 1 ? "muted" : "brand"}
                size="sm"
                className="shrink min-w-0"
              >
                <ButtonText
                  numberOfLines={1}
                  className={
                    index === totalItems - 1
                      ? "font-medium shrink"
                      : "font-normal shrink"
                  }
                >
                  {item.label}
                </ButtonText>
              </Button>
            </Link>
          ) : (
            <Text
              size="sm"
              numberOfLines={1}
              className={`shrink min-w-0 ${item.href ? "text-primary-600" : "text-typography-600"}`}
            >
              {item.label}
            </Text>
          )}
        </React.Fragment>
      ))}
    </HStack>
  );
};

export default Breadcrumbs;
